import React from 'react';
import { Globe } from 'lucide-react';

/** Opens the mini-website owner dashboard from the card owner panel header. */
export const OwnerMiniWebsiteButton: React.FC = () => (
  <button
    type="button"
    onClick={() => {
      window.location.assign('/website/dashboard');
    }}
    className="inline-flex items-center justify-center gap-2 px-3 py-2 bg-gradient-to-r from-teal-600 to-emerald-600 text-white rounded-lg shadow-sm hover:from-teal-700 hover:to-emerald-700 transition-all text-xs sm:text-sm font-medium whitespace-nowrap"
  >
    <Globe className="w-4 h-4" />
    <span className="hidden sm:inline">MiniWebsite</span>
    <span className="sm:hidden">Web</span>
  </button>
);

export default OwnerMiniWebsiteButton;
